import React, {useState} from "react";
import PropTypes from "prop-types";
import {AButton} from "@cisco-sbg-ui/magna-react";
import {useTranslation} from "react-i18next";
import {useDispatch, useSelector} from "react-redux";
import MarkdownModal from "components/MarkdownModal";
import {postIncidentNote} from "store/features/incidentDetailSlice";
import {selectIncidentDetailShortId} from "store/selectors";
import {
  sendIncidentDetailsResponseAddNoteTelemetry,
  sendIncidentDetailsResponseSaveNoteTelemetry
} from "api/telemetry/incidentsTelemetrics";

const PlaybookNoteButton = ({className, coa, stage}) => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const incidentId = useSelector(selectIncidentDetailShortId);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {id, title: task, short_description} = coa;

  const handleButtonClick = (e) => {
    e.stopPropagation();
    setIsModalOpen(true);
    sendIncidentDetailsResponseAddNoteTelemetry(incidentId, stage, task);
  };

  return (
    <>
      <AButton
        secondary
        small
        className={className}
        onClick={(e) => handleButtonClick(e)}>
        {t("notes.addNote")}
      </AButton>
      {isModalOpen && (
        <MarkdownModal
          description={short_description}
          extraTelemetryValues={[stage, task]}
          isOpen={isModalOpen}
          defaultValue={t("response.prepopulatedNoteText", {stage, task})}
          minEditorHeight={120}
          onSubmit={(value) =>
            dispatch(
              postIncidentNote({
                content: value,
                additionalEntities: [{entity_type: "coa", entity_id: id}]
              })
            )
          }
          setIsOpen={setIsModalOpen}
          setTelemetry={sendIncidentDetailsResponseSaveNoteTelemetry}
          showEditorOnLoad
          testId="ResponseActionNote"
          title={t("notes.addNote")}
        />
      )}
    </>
  );
};

export default PlaybookNoteButton;

PlaybookNoteButton.propTypes = {
  /**
   * COA object from stage task
   */
  coa: PropTypes.object,
  /**
   * Option to pass in a className to the 'Add Note' button
   */
  className: PropTypes.string,
  /**
   * The stage that the coa task is in
   */
  stage: PropTypes.string
};
